// tslint:disable-next-line:jsdoc-format
/** IE9, IE10 and IE11 requires all of the following polyfills. **/
import 'core-js/es6/array';
import 'core-js/es6/date';
import 'core-js/es6/function';
import 'core-js/es6/map';
import 'core-js/es6/math';
import 'core-js/es6/number';
import 'core-js/es6/object';
import 'core-js/es6/parse-float';
import 'core-js/es6/parse-int';
import 'core-js/es6/regexp';
import 'core-js/es6/set';
import 'core-js/es6/string';
import 'core-js/es6/symbol';
import 'core-js/es6/weak-map';
import 'core-js/es7/array';
import 'core-js/es7/object';
import 'url-search-params-polyfill';

import * as React from 'react';
import { ApolloProvider } from 'react-apollo';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import registerServiceWorker from './registerServiceWorker';
import App from './App';
import { ApolloClientFactory } from './domain/apolloClientFactory';
import { Auth0Provider } from '@auth0/auth0-react';

import ScrollTop from './components/ScrollTop';
import WebNavigation from './components/WebNavigations';

const AppWrapper = () => {
  return (
    <ApolloProvider client={ApolloClientFactory.GetClient()}>
      <BrowserRouter>
        <ScrollTop>
          <WebNavigation>
            <App />
          </WebNavigation>
        </ScrollTop>
      </BrowserRouter>
    </ApolloProvider>);
};

ReactDOM.hydrate(
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_DOMAIN || ''}
    audience={process.env.REACT_APP_AUTH0_AUDIENCE}
    clientId={process.env.REACT_APP_AUTH0_CLIENT_ID || ''}
    cacheLocation="localstorage"
    useRefreshTokens={true}
    redirectUri={process.env.REACT_APP_AUTH0_REDIRECT}
    >
    <AppWrapper />
  </Auth0Provider>,
  document.getElementById('root') as HTMLElement
);

// Cache for rendered pages is used, so there is no need to use service worker
// registerServiceWorker({
//   onUpdate: (registration: any) => {
//     window.location.reload();
//   },
// });

// Unregister eventually existing previous service worker and clean service worker cache
if ('navigator' in window && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    Promise.all(registrations.map((registration) => {
      console.log('Unregistering SW for', registration.scope);
      return registration.unregister();
    }))
      .then(() => {
        if ('caches' in window) {
          caches.keys()
            .then((keyList) => {
              return Promise.all(keyList.map((key) => {
                console.log('Cleaning cache', key);
                return caches.delete(key);
              }));
            });
        }
      });
  });
}



// WEBPACK FOOTER //
// ./src/index.tsx